import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { DataCard, SectionHeader, StatusPill, PriorityPill } from "../components/UI";
import { ArrowRight } from "lucide-react";

export default function ManagerDashboard() {
  const { user } = useAuth();
  const [cases, setCases] = useState([]);
  const [overview, setOverview] = useState(null);

  useEffect(() => {
    api.get("/analytics/overview").then(r => setOverview(r.data)).catch(()=>{});
    api.get("/cases", { params: { limit: 25 } }).then(r => setCases(r.data)).catch(()=>{});
  }, []);

  return (
    <div className="p-8 max-w-7xl mx-auto">
      <SectionHeader
        title={`Manager Overview`}
        subtitle={`${user.name}, cases from your team & workspace.`}
      />

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        <DataCard label="Open" value={overview?.open ?? ","} accent testid="mgr-open" />
        <DataCard label="Total" value={overview?.total ?? ","} testid="mgr-total"/>
        <DataCard label="Anonymous" value={overview?.anonymous ?? ","} testid="mgr-anon"/>
        <DataCard label="Resolved" value={overview?.resolved ?? ","} testid="mgr-resolved"/>
      </div>

      <div className="data-cell p-6">
        <div className="flex items-center justify-between mb-4">
          <div className="eyebrow">Recent Cases</div>
          <Link to="/cases" className="text-xs text-blue-700 hover:underline flex items-center gap-1">All cases <ArrowRight size={12}/></Link>
        </div>
        {cases.length === 0 ? (
          <div className="text-sm text-slate-500 py-8 text-center font-mono">No cases visible to your role yet.</div>
        ) : (
          <div className="space-y-2">
            {cases.map((c) => (
              <Link key={c.id} to={`/cases/${c.id}`} className="flex items-center justify-between px-4 py-3 border border-slate-200 row-hover rounded">
                <div className="min-w-0 flex-1">
                  <div className="text-sm font-medium text-slate-900 truncate">{c.title}</div>
                  <div className="text-[11px] text-slate-500 mt-0.5 font-mono">{c.case_number} · {c.category}</div>
                </div>
                <div className="flex items-center gap-2 shrink-0">
                  <PriorityPill priority={c.priority}/>
                  <StatusPill status={c.status}/>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
